import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { ConsultorioEspecialidadeService } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-especialidade.service';
import { ConsultorioEspecialidadeRequest } from '@/core/api/sicom-api/registro/medico/consultorio-privado/consultorio-especialidade.model';

@Injectable({ providedIn: 'root' })
export class ConsultorioEspecialidadeFeatureService extends CustomService {
    private readonly core = inject(ConsultorioEspecialidadeService);

    buscar(params: Pessoa & { idConsultorio: number }): Observable<ConsultorioEspecialidadeRequest[]> {
        return this.core.buscar(params).pipe(catchError(this.handleError));
    }
}
